export const MomentState = {
  LIVE: 'LIVE',
  ENDED: 'ENDED',
} as const;
export type MomentState = (typeof MomentState)[keyof typeof MomentState];
